import { useDialog } from "shared/dialog/use-dialog";
import { Dialog, DialogContent, Box, Button, Paper } from "@mui/material";
import DialogTitleStyled from "components/shared/dialog/dialog-title-styled";
import { ExtraWorkAgreementHistoryTable } from "../history/history-table";
import { ExtraWorkAgreementAuditLogEntry } from "api/generatedApi";
import { useTranslation } from "react-i18next";
import { DialogBaseProps } from "shared/dialog/types";
import { ScreenSizeEnum, useScreenSize } from "shared/use-screen-size";

interface HistoryDialogProps extends DialogBaseProps {
  auditLogEntries: ExtraWorkAgreementAuditLogEntry[];
}

const HistoryDialog = (props: HistoryDialogProps) => {
  const { isOpen, onClose, auditLogEntries } = props;
  const { t } = useTranslation();
  const { screenSize } = useScreenSize();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          margin: screenSize === ScreenSizeEnum.Mobile ? "32px 7px" : "32px",
          width: screenSize === ScreenSizeEnum.Mobile ? "100%" : "calc(100´%-64px)",
        },
      }}
    >
      <DialogTitleStyled title={t("dashboard.extraWorkAgreements.history.title")} onClose={onClose} isOpen={isOpen} />
      <DialogContent>
        <ExtraWorkAgreementHistoryTable auditLogEntries={auditLogEntries} />
      </DialogContent>
      <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          {t("common.back")}
        </Button>
      </Box>
    </Dialog>
  );
};

interface Props {
  auditLogEntries: ExtraWorkAgreementAuditLogEntry[];
}

export function useHistoryDialog(props: Props) {
  const { auditLogEntries } = props;
  const [openHistoryDialog, closeHistoryDialog] = useDialog(HistoryDialog);

  const handleClick = () => {
    openHistoryDialog({
      auditLogEntries,
      onClose: closeHistoryDialog,
    });
  };

  return handleClick;
}
